import { render, staticRenderFns } from "./hierarchy-upload.vue?vue&type=template&id=20689d0b&scoped=true"
import script from "./hierarchy-upload.vue?vue&type=script&lang=js"
export * from "./hierarchy-upload.vue?vue&type=script&lang=js"
import style0 from "./hierarchy-upload.vue?vue&type=style&index=0&id=20689d0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20689d0b",
  null
  
)

export default component.exports